import type { CrmTag } from '@integrations/crm-tags/contracts/crm-tag.contract';

import { inject } from '@angular/core';
import type { CreateQueryOptions } from '@tanstack/angular-query-experimental';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { retryTransient } from '@integrations/shared/retry-policy';

import { CrmTagsApiService } from '../api/crm-tags-api.service';

export const CRM_TAGS_QUERY_KEY = ['crm-tags'] as const;

type CrmTagsQueryOverrides = Partial<Omit<CreateQueryOptions<CrmTag[]>, 'queryKey' | 'queryFn'>>;

export function injectCrmTagsQuery(optionsFn?: () => CrmTagsQueryOverrides) {
    const api = inject(CrmTagsApiService);

    return injectQuery(() => ({
        staleTime: 5 * 60 * 1000, // 5 minutes
        // A definitive 4xx is how "the account does not have this" is detected, so it must
        // not be retried; a transient failure gets a few attempts instead of being mistaken
        // for that answer (#71534).
        retry: retryTransient,
        queryKey: CRM_TAGS_QUERY_KEY,
        queryFn: () => lastValueFrom(api.getTags()),
        ...optionsFn?.(),
    }));
}
